import { FETCH_ALL_IMPC_SUCCESS, FETCH_IMPC_WITH_MRD_SUCCESS } from '../actions/types/ImpcActionTypes';
import { AUTH_LOGOUT } from '../../../redux/actions/types/authActionTypes';

export const initialState = {
  impcsWithMrdsList: [],
  allImpcList: [],
};

const ImpcReducer = (state = initialState, action) => {
  switch (action.type) {
  case FETCH_IMPC_WITH_MRD_SUCCESS:
    return {
      ...state,
      impcsWithMrdsList: action.payload,
    };
  case FETCH_ALL_IMPC_SUCCESS:
    return {
      ...state,
      allImpcList: action.payload,
    };
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};

export default ImpcReducer;
